var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -38 512 512",
    height: 20,
    width: 20,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m497 406.503906h-6.257812v-391.503906c0-8.285156-6.714844-15-15-15h-111.75c-8.285157 0-15 6.714844-15 15v391.503906h-22.117188v-245.914062c0-8.285156-6.714844-15-15-15h-111.75c-8.285156 0-15 6.714844-15 15v245.914062h-22.117188v-100.328125c0-8.28125-6.714843-15-15-15h-111.75c-8.285156 0-15 6.71875-15 15v100.328125h-6.257812c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h482c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15zm-445.742188 0v-85.328125h81.75v85.328125zm163.867188 0v-230.914062h81.75v230.914062zm163.867188 0v-376.503906h81.75v376.503906zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessChart);
export default __webpack_public_path__ + "static/media/processChart.ff74d72299e1ce47571d86821df42710.svg";
export { ForwardRef as ReactComponent };